import Avatar from '@mui/material/Avatar';

const initialLetters = (text) => {
  const result = text
    .split(' ')
    .map((word) => word[0])
    .join('')
    .substring(0, 2)
    .toUpperCase();
  return result;
};

/**
 * LargeAvatar
 *
 * Componente de avatar grande, muestra imagen o iniciales.
 *
 * @component
 * @param {string} [baseUri] - Ruta base para la imagen
 * @param {string} [path] - Ruta de la imagen
 * @param {string} [color] - Color de fondo del avatar
 * @param {string} [name] - Nombre para iniciales
 * @returns {JSX.Element}
 */
export const LargeAvatar = ({ baseUri, path, color, name = '', ...props }) => {
  return (
    <Avatar
      {...props}
      sx={{
        aspectRatio: 1 / 1,
        width: '24rem',
        height: 'auto',
        backgroundColor: color,
      }}
      className="avatar md:mx-4"
      alt={name}
      src={path ? `${baseUri || ''}${baseUri ? '/' : ''}${path}` : undefined}
    >
      <p style={{ fontSize: '3.2em', fontWeight: 'normal', color: '#FFF' }}>
        {name !== undefined && initialLetters(name)}
      </p>
    </Avatar>
  );
};
